import type * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { StatusBannerAutoHide } from '@xing-com/banner';

import { BANNER_TIMEOUT } from '../../../constants';

export type DefaultAutohideErrorBannerType = {
  show: boolean;
  errorMessage?: string;
};

export const DefaultAutohideErrorBanner: React.FC<
  DefaultAutohideErrorBannerType
> = ({ show, errorMessage = '' }) => (
  <StatusBannerAutoHide {...{ show }} variant="error" timeout={BANNER_TIMEOUT}>
    <FormattedMessage
      id={
        errorMessage === 'DUPLICATE'
          ? 'DUPLICATE_SHARE_ERROR'
          : 'SHARE_BOX_DEFAULT_ERROR_MESSAGE'
      }
    />
  </StatusBannerAutoHide>
);
